import React from "react";
import type { TMatter } from "../../models/matter-model";
import { MatterInfoPresentational, MatterInfoPresentationalProps } from "../MatterInfo/MatterInfoPresentational";

import { MessageContainer, Severity } from "../Message/MessageContainer";
import { LoadingPresentational } from "../Loading/LoadingPresentational";

export type ViewType = "SEARCH" | "RECENT" | "DEFAULT";

export interface Props {
  viewType: ViewType;
  hasLoaded: boolean;
  resultsTitle: string;
  matters: TMatter[] | null;
  searchTextBox: React.ReactElement;

  assignToMatter: MatterInfoPresentationalProps["assignToMatter"];
}

export const SearchPresentational = (props: Props) => {
  const searchMargin = props.viewType === "SEARCH" ? "mt-1" : "mt-4";

  return (
    <div className="flex flex-col flex-1 justify-items-stretch min-h-0 max-h-full mt-4">
      <div className="flex flex-col min-h-0 items-stretch flex-1 max-h-full">
        <div className="mx-2">{props.searchTextBox}</div>
        <div className={`flex flex-col flex-1 min-h-0 ${searchMargin} bg-neutral-50`}>
          <div className="flex flex-col flex-1 min-h-0">
            <div className="p-3 font-semibold text-neutral-850">{props.resultsTitle}</div>
            {props.viewType === "DEFAULT" || !props.hasLoaded ? (
              <LoadingPresentational
                isLoading={true}
                title="Loading recent matters"
                severity={Severity.Information}
                message="Please wait while we load your recent matters..."
                onlyShowMessageIfIsLoading={true}
              />
            ) : props.matters && props.matters.length === 0 ? (
              <MessageContainer
                className="mx-2"
                severity={Severity.Information}
                title={props.viewType === "SEARCH" ? "No search results found" : "No recent matters available"}
                content={
                  props.viewType === "SEARCH"
                    ? "We couldn't find what you were looking for. Try to refine your search term for better results."
                    : "There are currently no matters with any activity. They will show up here once available. Try searching for matters instead."
                }
              />
            ) : (
              <></>
            )}

            <div className="overflow-y-auto scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-neutral-250 hover:scrollbar-thumb-neutral-700 active:scrollbar-thumb-neutral-500 scrollbar-track-transparent">
              {(props.matters ?? []).map((matter, i) => (
                <MatterInfoPresentational
                  key={matter.matterId}
                  className={`bg-white ${i === 0 ? "" : "mt-2"}`}
                  assignToMatter={props.assignToMatter}
                  allowAction={true}
                  matter={matter}
                  isSelected={false}
                  fullAreaSelect={true}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
